import React from "react";
import styled, { keyframes } from "styled-components";
import { BiLink, BiBuildings } from "react-icons/bi";
import { ImLocation, ImTwitter } from "react-icons/im";

const skeleton = keyframes`
to {
    opacity: 0.5;
}
`;

const Card = styled.div`
  border-radius: 10px;
  background-color: ${(props) => props.theme["lm-bg-content"]};
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0px 16px 30px -10px rgba(0, 0, 0, 0.2);
`;

const CardHeader = styled.section`
  display: flex;
  justify-content: space-around;
`;

const Image = styled.div`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const UserName = styled.div`
  margin-bottom: 10px;
  height: 12px;
  width: 150px;
  border-radius: 5px;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const UserId = styled.div`
  margin-bottom: 10px;
  height: 10px;
  width: 100px;
  border-radius: 5px;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const Bio = styled.p`
  margin-bottom: 10px;
  height: 10px;
  width: 270px;
  border-radius: 5px;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const JoinedDate = styled.span`
  height: 10px;
  width: 100px;
  border-radius: 5px;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const UserStatsContainer = styled.div`
  margin-top: 50px;
  margin-left: 170px;
  border-radius: 10px;
  background-color: ${(props) => props.theme["lm-bg"]};
  height: 50px;
  width: 70%;
  animation: ${skeleton} 1s ease infinite alternate;
`;

const ProfileBottom = styled.div`
  display: flex;
  flex-flow: column wrap;
  max-height: 70px;
  margin-left: 170px;
  margin-top: 50px;
`;

const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Info = styled.p`
  margin-left: 10px;
  height: 10px;
  width: 150px;
  border-radius: 5px;
  background-color: ${(props) => props.theme["lm-text"]};
  animation: ${skeleton} 1s ease infinite alternate;
`;

const Skeleton = () => {
  return (
    <Card>
      <CardHeader>
        <Image />
        <CardInfo>
          <UserName></UserName>
          <UserId />
          <Bio />
        </CardInfo>
        <JoinedDate></JoinedDate>
      </CardHeader>
      <UserStatsContainer></UserStatsContainer>
      <ProfileBottom>
        <ProfileInfo>
          <ImLocation />
          <Info></Info>
        </ProfileInfo>
        <ProfileInfo>
          <BiLink />
          <Info></Info>
        </ProfileInfo>
        <ProfileInfo>
          <ImTwitter />
          <Info></Info>
        </ProfileInfo>
        <ProfileInfo>
          <BiBuildings />
          <Info />
        </ProfileInfo>
      </ProfileBottom>
    </Card>
  );
};
export default Skeleton;
